module.exports = "/_next/static/images/networkArchitecture-7e5e2a4ef9e6e6b9c3036353b24ae2e2.webp";